import { get } from './apiUtils';

const defaultUrl = '/actions/';

export default {
  getActionList: () => get(defaultUrl),
};
